import { CloudUpload } from "@mui/icons-material";
import React from "react";

const ImageInput = ({ onChange }) => {
  const [imagePreview, setImagePreview] = React.useState(null);

  const handleChange = async (e) => {
    onChange(e);
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    console.log(url);
    setImagePreview(url);
  };

  return (
    <div className="image-input">
      <div className="image-input-title">Add Images</div>
      <input
        type="file"
        name="image"
        onChange={(e) => {
          handleChange(e);
        }}
      />
      {imagePreview ? (
        <img src={imagePreview} className="image-input-preview" alt="preview" />
      ) : (
        <div className="image-input-choose-image">
          <CloudUpload
            sx={{
              color: "#91227a",
              fontSize: "2rem",
            }}
          />
          <h3>Choose Image or Drag and Drop</h3>
        </div>
      )}
    </div>
  );
};

export default ImageInput;
